<script setup>
import { onMounted, ref, computed, reactive } from 'vue'
import {getOrderPayResultAPI,setCancelUsdtPayAPI} from '@/apis/order'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import {DEPLOY} from '@/utils/index'
import { useCartStore } from '@/stores/cartStore'
const cartStore = useCartStore()
const { t } = useI18n();
const router = useRouter()
const setIntervalsTime =ref(null);
const loading = ref(true)
const time = ref(0) // 倒计时时间
const data=reactive({
      payData:{
        pay_result:{
          pay_order_no:null,
          pay_price:null,
          receive_address:"",
          expire_time:null,
          currency:"",
        },
        pay_amount:null,
        redirect:""
      },
      colorObj: {
        dark: '#000',  // 暗色
        light: '#fff'  // 亮色
      }
})
// const usdPayModel=ref(false)
const orderStatus=ref()
const receive_address=ref()
// 查看支付结果
const handlePayResultOrder = async () => {
  const res = await getOrderPayResultAPI({ pay_order_no: data.payData.pay_result.pay_order_no })
  if(res.code==0){
    orderStatus.value=res.data.status
    if(res.data.status==1){
      ElMessage({ type: 'success', message: t('number39') });
      if( cartStore.usdData.redirect=='self'){
        router.push({ path:'/member/MallOrder' })
      }else{
        router.push({ path:'/member/PurchasingOrder' })
      }
    }
  }
}
const isMobile=ref(false)
onMounted(() => {
   isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  console.log(cartStore.usdData)
  data.payData={...cartStore.usdData}

  


  // usdPayModel.value=props.usdPayModel;
  receive_address.value=data.payData.pay_result.receive_address
  orderStatus.value = 1;
  time.value=data.payData.pay_result.expire_time*1000
  loading.value = true;
  handlePayResultOrder()
  setIntervalsTime.value = setInterval(() => {
    console.log(1111)
    handlePayResultOrder()
    }, 3000)
})

const usdPayClose=async ()=>{
  if(orderStatus.value!=1){
    
    const res = await setCancelUsdtPayAPI({ pay_order_no: cartStore.usdData.pay_result.pay_order_no})
    if(res.code==0){
      ElMessage({ type: 'success', message: t('setup562') });
      console.log( cartStore.usdData.redirect)
      if( cartStore.usdData.redirect=='self'){
        router.push({ path:'/member/MallOrder' })
      }else{
        router.push({ path:'/member/PurchasingOrder' })
      }
    }
  }else{
    console.log(cartStore.usdData.redirect)
    if( cartStore.usdData.redirect=='self'){
      router.push({ path:'/member/MallOrder' })
    }else{
      router.push({ path:'/member/PurchasingOrder' })
    }
  }
 
  
    // router.push({ path:'/member/buy' })
}
const timeChange = () => {}
const timeFinish = () => {
  console.log(111)
  loading.value = false
  clearInterval(setIntervalsTime.value)
}
// 组件卸载时清除定时器
onUnmounted(() => {
  if (setIntervalsTime.value) {
    clearInterval(setIntervalsTime.value);
    setIntervalsTime.value = null;
    console.log('定时器已清除');
  }
});
const copyText=async (url)=> {
      try {
        await navigator.clipboard.writeText(url);
       
        ElMessage({ type: 'success', message: t('cart74') });
      } catch (err) {
        ElMessage({ type: 'error', message: t('cart75') });
      }
    }
const usdtLine = [
  {
    value: 'TRON(TRC-20)',
    label: 'TRON(TRC-20)',
  }]
  const value=ref('TRON(TRC-20)')
</script>
<template>
  <div>
    <div class="container" v-if="isMobile==false">
  <!-- 需要显示创建订单的编号数据 -->
    <div class="dialogDiv">
        <div class="orderCondition">
          <div class="amount"> {{ data.payData.pay_result.pay_price}} USDT  <div class="hrdiv"></div> </div>
         
          <div class="orderInfo" style="margin-right: 60px;">
            <div class="infoleft"><div class="lable">{{$t('number49')}} ：</div><div class="lable">{{$t('setup105')}} ：</div></div>
            <div class="infoRight"><div class="value">{{ cartStore.usdData.pay_result.pay_order_no }}</div><div class="value"> <el-select v-model="value">
            <el-option
              v-for="(item,index) in usdtLine"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
            </el-select></div></div>
          
          </div>
          <div class="orderInfo">
            <div class="infoleft"><div class="lable">{{$t('setup103')}} ：</div><div class="lable">{{$t('setup104')}} ：</div></div>
            <div class="infoRight"><div class="value">{{ data.payData.pay_result.pay_price }} USD</div><div class="value">{{data.payData.pay_amount}}{{ data.payData.pay_result.currency }}</div></div>
          </div>
        </div>
        <div class="warnCss">
            <svg-icon icon-class="warning" />
            {{$t('setup106')}}
        </div>
        <div class="orderInfoFlex">
          <div class="qr">  <vue-qrcode v-if="receive_address" :value="receive_address" :width="220" :color="data.colorObj" style="border-radius: 8px;"></vue-qrcode></div>
          <div class="address">
            <div class="address-title">{{ $t('setup108') }}</div>
            <div class="address-copy">
              <div class="inputdiv"> {{ data.payData.pay_result.receive_address }} </div>
              <div class="copyBut" @click="copyText(data.payData.pay_result.receive_address)">copy</div>
            </div>
            <div class="danger">
              {{$t('setup109')}}
            </div>
            <div class="status">
              <div class="textCenter " v-if="orderStatus == 1">
                <svg-icon icon-class="success" />
                <div class="orderStatus"> {{$t('setup107')}}</div>
               
              </div>
              <div v-else>
                <div class="textCenter">
                  <div v-if="!loading" style="width: 50px;">
                      <svg-icon icon-class="success" v-if="orderStatus == 1" />
                      <svg-icon icon-class="warning"  v-else-if="orderStatus == 2"/>
                  </div>
                  <div class="rightLoading" v-loading="loading" v-else></div>
                  <div v-if="orderStatus == 0" class="orderStatus">{{ $t('setup111') }}</div>
                  <div v-else-if="orderStatus == 1" class="orderStatus">{{$t('setup112')}}</div>
                  <div v-else-if="orderStatus == 2" class="orderStatus">{{ $t('setup113') }}</div>
                  <div  @click="handlePayResultOrder" class="Result">
                    {{$t('setup114')}}
                  </div>
                </div>
               
                  
                </div>
            </div>
          </div>
          <div class="coutdownBut">
          <div class="coutdown" v-if="orderStatus != 1">
           <div>{{ $t('setup110') }}:</div> 
            <el-countdown

              ref="demoRef"
              :value="time"
              @change="timeChange"
              @finish="timeFinish"
            />
          </div>
          <div class="but" @click="usdPayClose">
              {{ orderStatus == 1 ? t('setup101') : t('setup100') }}
          </div>
        </div>
        </div>
       
    </div>
   </div>
    <div v-if="isMobile==true" class="phoneUSDT">
      
      <div class="topUSDT">
        
        <div class="amount HorizontalCenter"> {{ data.payData.pay_result.pay_price}} USDT</div>
          <div class="amountData">
            <div class="lable">{{$t('number49')}} ：<span class="value">{{cartStore.usdData.pay_result.pay_order_no  }}</span></div>
            <div  class="lable">{{$t('setup103')}} ：<span class="value">{{ data.payData.pay_result.pay_price }} USD</span></div>
            <div  class="lable">{{$t('setup104')}} ：<span class="value">{{data.payData.pay_amount}}{{ data.payData.pay_result.currency }}</span></div>
            <div  class="lable">{{$t('setup105')}} ：<span class="value">
              <el-select v-model="value">
              <el-option
                v-for="(item,index) in usdtLine"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
              </el-select>
            </span></div>
          </div>
      </div>
      <div class="PaymentCode">
        <div class="Codetitle">{{ $t('setup106') }}</div>
        <div class="qr">  <vue-qrcode v-if="receive_address" :value="receive_address" :width="200" :color="data.colorObj" style="border-radius: 8px;"></vue-qrcode></div>
        <div class="addressTitle">{{ $t('setup108') }}</div>
        <div class="address">
          <div class="addressValue">{{ data.payData.pay_result.receive_address }}</div><div @click="copyText(data.payData.pay_result.receive_address)" class="copy HorizontalCenter">{{ $t('setup60') }}</div>
        </div>
        <div class="hint">
          {{ $t('setup109') }}
        </div>
        <div class="Paymentstatus">
          <div class="textCenter " v-if="orderStatus == 1">
            <svg-icon icon-class="success" />
            <div class="orderStatus"> {{$t('setup107')}}</div>
            
          </div>
          <div v-else>
            <div class="textCenter">
              <div v-if="!loading" style="width: 50px;">
                  <svg-icon icon-class="success" v-if="orderStatus == 1" />
                  <svg-icon icon-class="warning"  v-else-if="orderStatus == 2"/>
              </div>
              <div class="rightLoading" v-loading="loading" v-else></div>
              <div  @click="handlePayResultOrder" class="orderStatus">
                {{$t('setup114')}}
              </div>
            </div>
            <div v-if="orderStatus == 0" class="StatusResult">{{ $t('setup111') }}</div>
            <div v-else-if="orderStatus == 1" class="StatusResult">{{$t('setup112')}}</div>
            <div v-else-if="orderStatus == 2" class="StatusResult">{{ $t('setup113') }}</div>

            </div>
        </div>
      
      </div> 
      <div class="Paymentbottom">
        <div class="coutdown" v-if="orderStatus != 1">
            <div>{{ $t('setup110') }}:</div> 
              <el-countdown
                ref="demoRef"
                :value="time"
                @change="timeChange"
                @finish="timeFinish"
              />
        </div>
        <div class="but" @click="usdPayClose">
            {{ orderStatus == 1 ? t('setup101') : t('setup100') }}
        </div>
      </div>
    </div>
</div>
  
</template>
<style scoped lang="scss">
:deep(.el-loading-spinner ){
  top: 100% !important;
  .circular {
    height: 18px !important;
    width: 18px !important;
  }

  .path {
      stroke: #409eff!important;
  }
}
:deep(.el-statistic__content) {
  font-family: MicrosoftYaHei;
  font-size: 14px !important;
  color: #666666 !important;
  line-height: 14px;
  text-align: left;
  font-style: normal;
    // font-weight: var(--el-statistic-content-font-weight);
}
.primary {
    color: #409eff;
}
.container{
  background: #eef0f1;
  width: 100%;
  padding: 20px 0;
}
.mgB20 {
    margin-bottom: 20px;
}
.dialogDiv {
  width: 1200px;
  background-color: #ffffff;
  margin: 0 auto;
  border-radius: 8px;
  padding: 30px 40px 60px 40px;
  .orderCondition{
    width: 1140px;
    height: 112px;
    background: #FFF5F1;
    border-radius: 12px;
    display: flex;
    padding: 0 40px;
    align-items: center;
    justify-content: space-between;
    .amount{
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 28px;
      color: #FC3938;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      display: flex;
      align-items: center;
    }
    .hrdiv{
      margin-left: 44px;
      width: 1px;
      height: 72px;
      border: 1px solid #F0C4C4;
    }
    .orderInfo{
      display: flex;


      .infoleft{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
      .infoRight{
        display: flex;
        flex-direction: column;
      }

      .lable{
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #666666;
        line-height: 36px;
        text-align: center;
        font-style: normal;
      }
      .value{
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #11192D;
        line-height: 36px;
        text-align: left;
        font-style: normal;
      }
    }
   
  }
  .warnCss {
    padding: 30px 0 16px 0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #666666;
    line-height: 19px;
    text-align: left;
    font-style: normal;
  }
  .orderInfoFlex{
    display: flex;
    .qr{
      width: 220px;
      height: 220px;
      background: #D8D8D8;
      border-radius: 8px;
      border: 1px solid #979797;
      margin-right: 20px;
    }
    .address{
      .address-title{
        font-family: MicrosoftYaHei;
font-size: 14px;
color: #666666;
line-height: 14px;
text-align: left;
font-style: normal;
      }
      .address-copy{
        display: flex;
        margin: 15px 0;
      .inputdiv{
        padding-left: 15px;
        width: 408px;
        height: 36px;
        background: #F3F6F8;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #11192D;
        line-height: 14px;
        text-align: left;
        font-style: normal;
        display: flex;
        align-items: center;
      }  
      .copyBut{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 76px;
        height: 36px;
        background: #1890FF;
        border-radius: 0px 4px 4px 0px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 19px;
        text-align: left;
        font-style: normal;
      }
      }
      .danger{
        margin-bottom: 32px;
        width: 544px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #888888;
        line-height: 26px;
        text-align: left;
        font-style: normal;
      }
      .status{
        .textCenter{
          display: flex;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          line-height: 14px;
          text-align: left;
          font-style: normal;
          .orderStatus{
            margin-left: 6px;
            color: #55A9FF;
          }
          .Result{
           margin-left: 15px;
            color: #666666;
          }
        }
        .rightLoading {
          width: 18px;
          height: 18px;
        }
      }
    }
    .coutdownBut{
      display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
      .coutdown{
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #666666;
        line-height: 14px;
        text-align: left;
        font-style: normal;
        display: flex;
        margin-bottom: 20px;
      }
      .but{
        width: 290px;
        height: 46px;
        background: #FFFFFF;
        border-radius: 23px;
        border: 1px solid #55A9FF;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #55A9FF;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        text-transform: uppercase;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    
  }
//   background-color: rgb(240, 240, 240);
}
.dialog-footer{
  text-align: right;
  padding: 20px 0;
}
.disFlexCenter{
    display: flex;
    align-items: center;
    justify-content: center;
}
/* 响应式设计 */
@media (max-width: 768px) {
  .phoneUSDT{
    height: 100%;
    background-color: #f4f4f4;
    padding: 108px 15px 115px 15px;
    .topUSDT{
      padding: 20px 15px 15px 15px;
      background: #FFFFFF;
      box-shadow: 0px 4px 20px 6px rgba(237,237,237,0.75);
      border-radius: 8px;
      .amount{
       
        height: 100px;
        background: #FFF5F1;
        border-radius: 8px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 28px;
        color: #FC3938;
        line-height: 28px;
        text-align: left;
        font-style: normal;
      }
      .amountData{
        padding-top: 13px;
        .lable{
        padding-bottom: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        line-height: 12px;
        text-align: left;
        font-style: normal; 
        .value{
          font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 12px;
        text-align: left;
        font-style: normal;
        }
      }
      }
      
    }
    .PaymentCode{
      margin-top: 15px;
      padding: 25px 15px 20px 15px;
      background: #FFFFFF;
      box-shadow: 0px 4px 20px 6px rgba(237,237,237,0.75);
      border-radius: 8px;
      .Codetitle{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        line-height: 12px;
        text-align: left;
        font-style: normal;
        margin-bottom: 17px;
      }
      .qr{
        width: 200px;
        height: 200px;
        background: #F0F2F8;
        border-radius: 8px;
        margin: 0 auto;
      }
      .addressTitle{
        padding-top: 25px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 14px;
        text-align: left;
        font-style: normal;
      }
      .address{
        margin-top: 13px;
        width: 315px;
        height: 37px;
        background: #F0F9FF;
        display: flex;
        .addressValue{
          width: 240px;
          overflow-wrap: break-word;
        }
        .copy{
          padding: 0 21px;
          height: 37px;
          background: #1890FF;
          border-radius: 0px 4px 4px 0px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 20px;
          text-align: left;
          font-style: normal;
        }
      }
    } 
    .hint{
      padding: 12px 0 8px 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #888888;
      line-height: 26px;
      text-align: left;
      font-style: normal;
    }
    .Paymentstatus{
      height: 84px;
      background: #F5F5F5;
      border-radius: 4px;
      padding: 22px 0 21px 0;
        .textCenter{
          display: flex;
          justify-content: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          line-height: 14px;
          text-align: left;
          font-style: normal;
          .orderStatus{
            margin-left: 6px;
            color: #55A9FF;
          }
          
        }
        .StatusResult{
            padding-top: 9px;
            display: flex;
            justify-content: center;
            margin-left: 15px;
            color: #666666;
          }
        .rightLoading {
          width: 18px;
          height: 18px;
        }
        :deep(.el-loading-mask){
          background: #F5F5F5;
        }
    }
    .Paymentbottom{
      position: fixed;
      left: 0;
      bottom: 0;
      background: #fff;
      width: 100%;
      display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 15px 20px 10px 20px;
        z-index: 9999999;
     
       
   
        .coutdown{
          font-family: MicrosoftYaHei;
          font-size: 14px;
          color: #666666;
          line-height: 14px;
          text-align: left;
          font-style: normal;
          display: flex;
          margin-bottom: 20px;
        }
        .but{
          height: 40px;
          background: #FFFFFF;
          border-radius: 20px;
          border: 1px solid #55A9FF;
          width: 100%;
          background: #FFFFFF;
        
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 16px;
          color: #55A9FF;
          line-height: 21px;
          text-align: left;
          font-style: normal;
          text-transform: uppercase;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      
    }
  }
  
}
</style>